<template>
  <div class="container">
    <!--  搜索  -->
    <search-bar
        :isCallback="true"
        v-model="params.paperName" :index="2" @doSearch="(v)=>{params.paperName=v;queryPageList()}"></search-bar>
    <!--  分类筛选  -->
    <!--  课程筛选  -->
    <course-filter
        @classifyLevelOne="(v,j)=>{params.classifyLevelOne=v;params.classifyLevelTwo=j;queryPageList()}"
        @classifyLevelTwo="(v,j)=>{params.classifyLevelTwo=v;params.classifyLevelOne=j;queryPageList()}"
        @gradeData="(v)=>{params.classifyLevelGrade=v;queryPageList()}"></course-filter>
    <!--  条件筛选  -->
<!--    <filters @change2="(v)=>{params.isPay=v;queryPageList()}"
             @change3="(v)=>{params.studyCountSort=v;queryPageList()}"
             @change4="(v)=>{params.priceSort=v;queryPageList()}"></filters>-->

    <!--  数据列表  -->
    <div class="g-flex g-row-center">
      <div class="total-width g-flex g-flex-wrap " v-loading="loading">
        <div class="g-m-t-10 g-m-r-10" v-for="item in data" :key="item.id">
          <test-card :data="item"></test-card>
        </div>
      </div>
    </div>

    <!--  分页  -->
    <div class="g-flex g-row-center g-m-t-30">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[12, 24, 48]"
          :page-size="12"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import SearchBar from "@/components/search-bar";
import SortSelection from "@/components/sort-selection";
import Filters from "@/components/filters";
import TestCard from "@/components/test-card";
import CourseFilter from "@/components/course-filter";
import {getPageList} from "@/api/education/paper";
export default {
  name: "examination",
  components:{
    TestCard,
    SortSelection,
    SearchBar,
    Filters,
    CourseFilter
  },
  data(){
    return{
      dataList:[],
      data:[],
      total: 1,
      loading: false,
      currentPage:1,
      params: {
        size: 12,
        current: 1,
        paperName: null,
        classifyLevelGrade: null,
        classifyLevelOne: null,
        classifyLevelTwo: null,
        isPay: null,
        studyCountSort: null,
        priceSort: null,

      }
    }
  },
  created() {
    debugger
    if(this.$route.query.s){
      this.params.paperName=this.$route.query.s
    }
    this.queryPageList()
  },
  methods:{
    queryPageList(){
      this.loading=true;
      getPageList(this.params).then(res=>{
        this.total = res.total
        this.data = res.records
        this.loading=false;
      }, error => {
        this.loading = false
      })
    },
    // 页数切换
    handleSizeChange(val) {
      this.params.size = val
      this.queryPageList()
    },
    // 当前页切换
    handleCurrentChange(val) {
      this.params.current = val
      this.queryPageList()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
